import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ClientSuccessStories from './pages/client-success-stories';
import PlumbingServices from './pages/plumbing-services';
import Contact from './pages/contact';
import CommercialExperience from './pages/commercial-experience';
import Homepage from './pages/homepage';
import ElectricalServices from './pages/electrical-services';
import SignIn from './pages/auth/SignIn';
import SignUp from './pages/auth/SignUp';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import AdminDashboard from './pages/admin/AdminDashboard';
import CustomerDashboard from './pages/customer/CustomerDashboard';
import ScheduleService from './pages/schedule-service';
import { AuthProvider } from './contexts/AuthContext';
import DriveThruCleanup from './pages/drive-thru-cleanup';
import EquipmentRepair from './pages/equipment-repair';
import FatTraps from './pages/fat-traps';
import PaintingServices from './pages/painting-services';
import IndustrialRefrigerators from './pages/industrial-refrigerators';
import RoadMarkings from './pages/road-markings';

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <ScrollToTop />
          <RouterRoutes>
            {/* Public Routes */}
            <Route path="/" element={<Homepage />} />
            <Route path="/client-success-stories" element={<ClientSuccessStories />} />
            <Route path="/plumbing-services" element={<PlumbingServices />} />
            <Route path="/schedule-service" element={<ScheduleService />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/commercial-experience" element={<CommercialExperience />} />
            <Route path="/homepage" element={<Homepage />} />
            <Route path="/electrical-services" element={<ElectricalServices />} />
            <Route path="/drive-thru-cleanup" element={<DriveThruCleanup />} />
            <Route path="/equipment-repair" element={<EquipmentRepair />} />
            <Route path="/fat-traps" element={<FatTraps />} />
            <Route path="/painting-services" element={<PaintingServices />} />
            <Route path="/industrial-refrigerators" element={<IndustrialRefrigerators />} />
            <Route path="/road-markings" element={<RoadMarkings />} />
            
            {/* Auth Routes */}
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            
            {/* Protected Routes */}
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/customer/dashboard" element={<CustomerDashboard />} />
            
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
